import { Box, Stack, Typography } from "@mui/material";
import React from "react";

const AssignHeaderWrapper = ({ children }) => {
  return (
    <>
      <Stack direction="row" spacing={0.5} alignItems="center">
        <Box sx={{ width: 2, height: 16 }} bgcolor="primary.main" />
        <Typography variant="body2" fontWeight="fontWeightBold">
          {children}
        </Typography>
      </Stack>
    </>
  );
};

export default AssignHeaderWrapper;
